export default {
    getCurrentSite(state){
        return state.currentSite;
    },
    getSites(state){
        return state.sites;
    },
}